// extracted by mini-css-extract-plugin
export default {"container":"FilteredCategory_container__svrS9","title":"FilteredCategory_title__9F+XJ","btn":"FilteredCategory_btn__Qvu0F","wrapper":"FilteredCategory_wrapper__GnXBa"};